import React from 'react'
import {isArrayAndNotEmpty} from '../../observations/Utils'

export const hospitalColumnList = [
    {
        field: 'hospitalNumber',
        header: 'Org. Number',
        initialShown: true,
        body: rowData => rowData.hospitalNumber || 'N/A',
    },
    {
        field: 'name',
        header: 'Organization',
        initialShown: true,
        body: rowData => (
            <div className="flex aligns-item-center">
                {rowData.name ? (
                    <React.Fragment>
                        {rowData?.logo ? (
                            <div className="mr-2">
                                <img
                                    src={rowData.logo}
                                    style={{width: 30, height: 30}}
                                />
                            </div>
                        ) : (
                            ''
                        )}
                        <div className="align-self-center">{rowData.name}</div>
                    </React.Fragment>
                ) : (
                    'N/A'
                )}
            </div>
        ),
    },
    {
        field: 'description',
        header: 'Description',
        initialShown: true,
        body: rowData => rowData.description || 'N/A',
    },
    {
        header: 'Number of Sub Hospitals',
        field: 'children',
        initialShown: true,
        body: rowData =>
            isArrayAndNotEmpty(rowData?.children) ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {rowData?.children?.length}{' '}
                        <span className="lowercase">hospital(s) in total</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            ),
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
    {
        header: 'Number of HC.Practitioners',
        field: 'numberOfHCP',
        initialShown: false,
        body: rowData =>
            rowData?.numberOfHCP ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {rowData.numberOfHCP}{' '}
                        <span className="lowercase">practitioner(s)</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            ),
    },
    {
        header: 'Number of Patients',
        field: 'numberOfPatients',
        initialShown: false,
        body: rowData =>
            rowData?.numberOfPatients ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {rowData.numberOfPatients}{' '}
                        <span className="lowercase">patient(s)</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            ),
    },
    {
        header: 'Address Type',
        field: 'type',
        initialShown: false,
        body: rowData => rowData.type || 'N/A',
    },
    {
        header: 'Address',
        field: 'address',
        initialShown: false,
        body: rowData => rowData.address || 'N/A',
    },
    {
        header: 'Address Line 1',
        field: 'addressLine1',
        initialShown: false,
        body: rowData => rowData.addressLine1 || 'N/A',
    },
    {
        header: 'Address Line 2',
        field: 'addressLine2',
        initialShown: false,
        body: rowData => rowData.addressLine2 || 'N/A',
    },
    {
        header: 'Address Line 3',
        field: 'addressLine3',
        initialShown: false,
        body: rowData => rowData.addressLine3 || 'N/A',
    },
    {
        header: 'Address Line 4',
        field: 'addressLine4',
        initialShown: false,
        body: rowData => rowData.addressLine4 || 'N/A',
    },
    {
        header: 'City',
        field: 'city',
        initialShown: false,
        body: rowData => rowData.city || 'N/A',
    },
    {
        header: 'State',
        field: 'state',
        initialShown: false,
        body: rowData => rowData.state || 'N/A',
    },
    {
        header: 'Country',
        field: 'country',
        initialShown: false,
        body: rowData => rowData.country || 'N/A',
    },
    {
        header: 'Postal Code',
        field: 'postalCode',
        initialShown: false,
        body: rowData => rowData.postalCode || 'N/A',
    },
    {
        header: 'Phone',
        field: 'phone',
        initialShown: false,
        body: rowData => (rowData?.phone?.length > 9 ? rowData?.phone : 'N/A'),
    },
]
